export default __webpack_public_path__ + "static/media/gears.7454e243.svg";